import styled from '@emotion/styled';

export const Container = styled.div`
	height: auto;
	display: flex;
	flex-direction: column;
	align-items: start;
	justify-content: center;
	width: 100%;
	padding: 6rem 10rem;
	overflow: scroll;
`;
export const TextContainer = styled.div`
	margin-top: 6rem;
`;

export const LinkViewer = styled.span`
	font-weight: 700;
	text-decoration: underline;
	cursor: pointer;
	color: var(--blue);
`;
